// document.addEventListener("DOMContentLoaded", function () {
//   if( ShopifyAnalytics.meta.page.pageType == "home" ){
//      document.querySelector(".newsletter-popup-section")?.classList.add("show-popup")
//   }
//     // const popupShown = localStorage.getItem("popupShown");

//     // if (!popupShown) {
//     //     document.querySelector(".newsletter-popup-section")?.classList.add("show-popup")
//     //     localStorage.setItem("popupShown", "true");
//     // }
// });

// document.querySelector(".cross-icon-popup.icon-block__media").addEventListener("click", function() {
//   document.querySelector(".newsletter-popup-section.show-popup")?.classList.remove("show-popup");
// });


// document.addEventListener("DOMContentLoaded", function () {
//     const popup = document.querySelector(".newsletter-popup-section");
//     const popupShown = localStorage.getItem("popupShown");
//     const second_pop = localStorage.getItem("secondpopup");
//     if (!popupShown) {
//     popup?.classList.add("show-popup");
//     localStorage.setItem("popupShown", "true");
// } else if (!second_pop) {
//     document.querySelector(".discount-popup")?.style.display = "block";
// }
// });


// document.addEventListener('DOMContentLoaded', () => {
//     const copyButton = document.querySelector('.discount-code-block__copy');
//     const discountInput = document.querySelector('.discount-code-input');
//     copyButton.addEventListener('click', () => {
//       navigator.clipboard.writeText(discountInput.value);
//     });
//   });

//   document.addEventListener('DOMContentLoaded', () => {
//     const crossbtn = document.querySelector('.discount-popup .cross-icon-popup');
//     const popup = document.querySelector('.discount-popup');
//     crossbtn?.addEventListener('click', () => {
//         popup.style.display = "none";
//         localStorage.setItem("secondpopup", "true");
//     });
// });


document.addEventListener("DOMContentLoaded", () => {
    const newsletterPopup = document.querySelector(".newsletter-popup-section");
    const discountPopup = document.querySelector(".discount-popup");
    const copyButton = document.querySelector(".discount-code-block__copy");
    const discountInput = document.querySelector(".discount-code-input");
    const crossBtn = document.querySelector(".discount-popup .cross-icon-popup");
    const shopNowBtn = document.querySelector(".discount-popup a.button");

    const popupShown = localStorage.getItem("popupShown");
    const secondPopupShown = localStorage.getItem("secondpopup");
    const willshowsecondpopup = localStorage.getItem("willshowsecondpopup");
    const isThemeEditor = window.isThemeEditor === true;


if (isThemeEditor) {
        document.querySelectorAll(".popup-preview-enabled.newsletter-popup-section, .popup-preview-enabled.discount-popup").forEach((popup) => {
            popup.classList.add("show-popup");
            if (popup.classList.contains("discount-popup")) {
                popup.style.display = "block";
            }
        });

        const newsletterCross = document.querySelector(".newsletter-popup-section .cross-icon-popup");
        const discountCross = document.querySelector(".discount-popup .cross-icon-popup");

        newsletterCross?.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            console.log("Newsletter Cross");
            newsletterPopup?.classList.remove("show-popup");
        });

        discountCross?.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            console.log("Discount Cross");
            discountPopup?.classList.remove("show-popup");
            discountPopup.style.display = "none";
        });
}

    if (!isThemeEditor && !popupShown) {
        setTimeout(() => {
            newsletterPopup?.classList.add("show-popup");
            // localStorage.setItem("popupShown", "true");    
        }, 5000);
    } else if (!isThemeEditor && !secondPopupShown && willshowsecondpopup) {
        if (discountPopup) {
            discountPopup.style.display = "block";
            discountPopup.classList.add("show-popup");
            localStorage.removeItem("willshowsecondpopup");
        }
    }

    copyButton?.addEventListener("click", () => {
        navigator.clipboard
            .writeText(discountInput.value)
            .then(() => {
                console.log("Copied!");
            })
            .catch((err) => {
                console.error("Failed to copy:", err);
            });
    });

    function closeDiscountPopup() {
        if (discountPopup) {
            discountPopup.classList.remove("show-popup");
            discountPopup.style.display = "none";
        }
        localStorage.setItem("secondpopup", "true");
    }

    crossBtn?.addEventListener("click", closeDiscountPopup);
    shopNowBtn?.addEventListener("click", closeDiscountPopup);
});

document.addEventListener("DOMContentLoaded", () => {
    const popup = document.querySelector(".newsletter-popup-section");
    const remove_button = document.querySelector(".cross-icon-popup");
    if(!popup){
        return;
    }
    remove_button?.addEventListener("click", ()=>{
        popup.classList.remove("show-popup");
    });
});


document.addEventListener("click", (event) => {
    const button = event.target.closest(".email-signup__input-group .email-signup__button");

    if (!button) return;

    localStorage.setItem("popupShown", "true");
});
